import { useEffect, useState } from "react";
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useNavigate } from "react-router";

export const SiteHeader = ({ title }) => {

    const [opened, setOpened] = useState(false);

    const appRoutes = [
        { path: "/", pageTitle: 'Startseite' },
        { path: "/about", pageTitle: 'Über uns' },
        { path: "/services", pageTitle: "Leistungen" },
        { path: "/contact", pageTitle: "Kontakt" }
    ];

    const navigateTo = useNavigate();

    useEffect(() => {
        document.title = title
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }, [title]);

    // useEffect(() => {

    // }, [])


    return (
        <header className="app-header">
            <div className="app-logo">
                <img
                    className="logo-img"
                    alt=""
                    src="/act-logo.png"
                />
            </div>
            <div className="mobi-nav-menu-button">
                <button
                    className="tr-btn menu-btn"
                    onClick={() => setOpened(v => !v)}
                >
                    <FontAwesomeIcon
                        icon={opened ? faClose : faBars}
                        color="#ffffff"
                        size={22}
                    />
                </button>
            </div>
            <div
                className={classNames(
                    "app-nav-pane",
                    { 'open-pane': opened }
                )}
            >
                <a href="tel:+4917622006681">
                    <button
                        className={classNames(
                            "nav-menu-button",
                            "call-button"
                        )}
                    >
                        {"+4917622006681"}
                    </button>
                </a>
                {appRoutes.map((appRoute, index) => (
                    <button
                        className={classNames(
                            "nav-menu-button",
                            "tr-btn",
                            { 'selected': title === appRoute.pageTitle }
                        )}
                        key={index}
                        onClick={() => navigateTo(appRoute.path)}
                    >
                        {appRoute.pageTitle}
                    </button>
                ))}
                <button
                    className={classNames(
                        "nav-menu-button",
                        "header-order",
                        { 'selected': title === "Reinigungskraft anfordern" }
                    )}
                    onClick={() => navigateTo("/cleanerrequest")}
                >
                    {"Reinigungskraft anfordern"}
                </button>
            </div>
        </header>
    )
}